import { code } from '@streamdown/code'
import { math } from '@streamdown/math'
import { mermaid } from '@streamdown/mermaid'
import remarkBreaks from 'remark-breaks'
import { defaultRemarkPlugins, Streamdown } from 'streamdown'

interface MarkdownContentProps {
  content: string
  className?: string
}

const remarkPlugins = [...Object.values(defaultRemarkPlugins), remarkBreaks]

function MarkdownContent({ content, className }: MarkdownContentProps) {
  return (
    <Streamdown
      mode="static"
      controls={true}
      plugins={{ code, math, mermaid }}
      remarkPlugins={remarkPlugins}
      className={className}
    >
      {content}
    </Streamdown>
  )
}

export default MarkdownContent
